import React from 'react'
import styled from 'styled-components'
import useShop from '../context/AppContext'
import { IconTabs } from '../assets/icons'
import { images } from '../constants'
import { motion } from 'framer-motion'

const SectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: calc(100dvh - 100px);
  padding: 100px 0 140px;
  @media screen and (max-width: 1023px) {
    padding: 100px 0 120px;
  }
  @media screen and (max-width: 800px) {
    padding: 60px 0 100px;
  }
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
  }
`
const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: calc(100% - 500px);
  padding: 0 30px 0 0;
  @media screen and (max-width: 1023px) {
    width: calc(100% - 400px);
    padding: 0 15px 0 0;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    padding: 0 0 20px 0;
  }
  h1 {
    line-height: 1.25;
    margin-bottom: 15px;
  }
  h3 {
    font-size: var(--fz-lg);
    color: var(--text);
    line-height: 1.5;
    font-weight: 400;
    margin-bottom: 30px;
  }
`
const RightColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 500px;
  height: auto;
  .level-1 {
    display: block;
    width: 500px;
    img {
      width: 100%;
      height: auto;
    }
  }
  .level-2,
  .level-3,
  .level-4,
  .level-5,
  .level-6 {
    display: block;
    width: 500px;
    position: absolute;
    img {
      width: 100%;
      height: auto;
    }
  }
  @media screen and (max-width: 1023px) {
    width: 400px;
    .level-1,
    .level-2,
    .level-3,
    .level-4,
    .level-5,
    .level-6 {
      width: 400px;
    }
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    align-items: flex-start;
    .level-1,
    .level-2,
    .level-3,
    .level-4,
    .level-5,
    .level-6 {
      width: 100%;
      max-width: 500px;
    }
  }
`
const InnerService = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  img {
    opacity: 0.9;
    width: 20px;
  }
  .service-style {
    display: inline-block;
    margin: 0 0 1px 12px;
    color: var(--text);
    font-size: var(--fz-sm);
    font-weight: 500;
    line-height: 1;
  }
`
const ArticleHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 86%;
  max-width: var(--max-width);
  margin: 90px auto 20px;
  svg.tab-icon {
    width: 52px;
    height: 52px;
    path {
      fill: var(--service-design);
    }
  }
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
    margin: 60px auto 20px;
  }
`
const ArticleColumns = styled.div`
  display: flex;
  flex-direction: row;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;
  color: var(--text);
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
  }
`
const ArticleOne = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 40%;
  padding-right: 40px;
  h3 {
    margin-bottom: 20px;
    font-family: var(--font-sans);
    font-size: var(--fz-md);
    font-weight: 600;
    line-height: 1.5;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    padding-right: 0px;
    padding-bottom: 20px;
  }
`
const ArticleTwo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  position: relative;
  width: 60%;
  margin-top: -40px;
  .article-two {
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 0 0 1px rgb(0 0 0 / 1%), 0 25px 25px rgb(0 0 0 / 3%), 0 15px 15px rgb(0 0 0 / 6%), 0 10px 8px rgb(0 0 0 / 5%), 0 4px 4px rgb(0 0 0 / 4%), 0 2px 2px rgb(0 0 0 / 3%);
    background-color: var(--black-medium);
    ul {
      display: block;
      margin-left: 18px;
      li {
        margin: 8px 0;
      }
    }
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    margin-top: 20px;
    .article-two {
      padding: 35px 25px;
    }
  }
`

const ServiceHeroNewsletterPopupsDesign = () => {
  const { preloaderExecuted, navigationExecuted } = useShop()

  const icon = <img src={images.service_card_shopify} alt="Shopify" />
  const service = <span className="service-style">Design Services</span>
  const title = <h1>Shopify Newsletter Popups Design.</h1>
  const subtitle = <h3>Need an attention-grabbing newsletter popup? I can design newsletter pop-ups that feel like a cohesive part of your site and helps you attract new subscribers.</h3>

  return (
    <SectionWrapper>
      <SectionContainer>
        {preloaderExecuted && navigationExecuted ? (
          <LeftColumn>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 0.1, duration: 0.3 }} className="start-opacity">
              <InnerService>
                {icon}
                {service}
              </InnerService>
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 0.2, duration: 0.3 }} className="start-opacity">
              {title}
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 0.3, duration: 0.3 }} className="start-opacity">
              {subtitle}
            </motion.div>
          </LeftColumn>
        ) : (
          <LeftColumn>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1, duration: 0.3 }} className="start-opacity">
              <InnerService>
                {icon}
                {service}
              </InnerService>
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.1, duration: 0.3 }} className="start-opacity">
              {title}
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.2, duration: 0.3 }} className="start-opacity">
              {subtitle}
            </motion.div>
          </LeftColumn>
        )}
        {preloaderExecuted && navigationExecuted ? (
          <RightColumn>
            <motion.div animate={{ scale: [1.05, 1], opacity: [0, 1] }} transition={{ delay: 0.3, duration: 0.5 }} className="start-opacity level-1">
              <img src={images.roberteberhard_service_theme_background} alt="Image Newsletter Popups Design" />
            </motion.div>
            <motion.div animate={{ y: [10, 0], opacity: [0, 1] }} transition={{ delay: 0.6, duration: 0.5 }} className="start-opacity level-2">
              <img src={images.roberteberhard_service_design_theme_newsletter_popups_design_1} alt="" />
            </motion.div>
            <motion.div animate={{ y: [-30, 0], scale: [1.1, 1], opacity: [0, 1] }} transition={{ delay: 0.7, duration: 0.5 }} className="start-opacity level-3">
              <img src={images.roberteberhard_service_design_theme_newsletter_popups_design_2} alt="" />
            </motion.div>
            <motion.div animate={{ x: [180, 0], y: [220, 0], opacity: [0, 1] }} transition={{ delay: 0.8, duration: 0.5 }} className="start-opacity level-4">
              <img src={images.roberteberhard_service_design_theme_newsletter_popups_design_3} alt="" />
            </motion.div>
          </RightColumn>
        ) : (
          <RightColumn>
            <motion.div animate={{ scale: [1.05, 1], opacity: [0, 1] }} transition={{ delay: 1.2, duration: 0.5 }} className="start-opacity level-1">
              <img src={images.roberteberhard_service_theme_background} alt="Image Newsletter Popups Design" />
            </motion.div>
            <motion.div animate={{ y: [10, 0], opacity: [0, 1] }} transition={{ delay: 1.5, duration: 0.5 }} className="start-opacity level-2">
              <img src={images.roberteberhard_service_design_theme_newsletter_popups_design_1} alt="" />
            </motion.div>
            <motion.div animate={{ y: [-30, 0], scale: [1.1, 1], opacity: [0, 1] }} transition={{ delay: 1.6, duration: 0.5 }} className="start-opacity level-3">
              <img src={images.roberteberhard_service_design_theme_newsletter_popups_design_2} alt="" />
            </motion.div>
            <motion.div animate={{ x: [180, 0], y: [220, 0], opacity: [0, 1] }} transition={{ delay: 1.7, duration: 0.5 }} className="start-opacity level-4">
              <img src={images.roberteberhard_service_design_theme_newsletter_popups_design_3} alt="" />
            </motion.div>
          </RightColumn>
        )}
      </SectionContainer>

      {preloaderExecuted && navigationExecuted ? (
        <ArticleHeader>
          <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 0.9, duration: 0.3 }} className="start-opacity">
            <IconTabs name="shopify-support" />
          </motion.div>
        </ArticleHeader>
      ) : (
        <ArticleHeader>
          <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.8, duration: 0.3 }} className="start-opacity">
            <IconTabs name="shopify-support" />
          </motion.div>
        </ArticleHeader>
      )}

      {preloaderExecuted && navigationExecuted ? (
        <ArticleColumns>
          <ArticleOne>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1, duration: 0.3 }} className="start-opacity">
              <h3>Shopify Newsletter Popups Design is a great way to capture the attention of potential customers and increase your email list.</h3>
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.1, duration: 0.3 }} className="start-opacity">
              <p className="mb-15">With email marketing on Shopify, you can target customers with relevant offers and promotions, which can help increase sales and conversions.</p>
              <p className="mb-15">You can track the performance of your campaigns so you can make adjustments and optimize their campaigns for better results.</p>
              <p>Email marketing is cost-effective, making it a great way to reach your customers without breaking the bank.</p>{' '}
            </motion.div>
          </ArticleOne>
          <ArticleTwo>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.2, duration: 0.3 }} className="start-opacity">
              <div className="article-two">
                <p className="mb-15">As a Shopify designer and developer, implementing newsletter popups that create a unique shopping experience for my clients is an important task. The best way to design these popups is to make sure they are visually appealing and easy to use.</p>
                <ul className="mb-15">
                  <li>This can be achieved by using bright colors, attractive fonts, and a simple layout.</li>
                  <li>Additionally, it is important to make sure that the popup is relevant to the customer's interests and needs.</li>
                  <li>This can be done by including personalized content such as product recommendations, discounts, and special offers.</li>
                  <li>Finally, it is important to ensure that the popup is easy to close and does not interfere with the customer's shopping experience.</li>
                </ul>
                <p>By following these tips, I can create an effective and engaging Newsletter Popup that will help to create a unique shopping experience for your customers.</p>
              </div>
            </motion.div>
          </ArticleTwo>
        </ArticleColumns>
      ) : (
        <ArticleColumns>
          <ArticleOne>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.9, duration: 0.3 }} className="start-opacity">
              <h3>Shopify Newsletter Popups Design is a great way to capture the attention of potential customers and increase your email list.</h3>
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 2, duration: 0.3 }} className="start-opacity">
              <p className="mb-15">With email marketing on Shopify, you can target customers with relevant offers and promotions, which can help increase sales and conversions.</p>
              <p className="mb-15">You can track the performance of your campaigns so you can make adjustments and optimize their campaigns for better results.</p>
              <p>Email marketing is cost-effective, making it a great way to reach your customers without breaking the bank.</p>
            </motion.div>
          </ArticleOne>
          <ArticleTwo>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 2.1, duration: 0.3 }} className="start-opacity">
              <div className="article-two">
                <p className="mb-15">As a Shopify designer and developer, implementing newsletter popups that create a unique shopping experience for my clients is an important task. The best way to design these popups is to make sure they are visually appealing and easy to use.</p>
                <ul className="mb-15">
                  <li>This can be achieved by using bright colors, attractive fonts, and a simple layout.</li>
                  <li>Additionally, it is important to make sure that the popup is relevant to the customer's interests and needs.</li>
                  <li>This can be done by including personalized content such as product recommendations, discounts, and special offers.</li>
                  <li>Finally, it is important to ensure that the popup is easy to close and does not interfere with the customer's shopping experience.</li>
                </ul>
                <p>By following these tips, I can create an effective and engaging Newsletter Popup that will help to create a unique shopping experience for your customers.</p>
              </div>
            </motion.div>
          </ArticleTwo>
        </ArticleColumns>
      )}
    </SectionWrapper>
  )
}

export default ServiceHeroNewsletterPopupsDesign
